/**
 * Google, Meta, OpenAI, and X tracking runs only on the production site.
 * Set this to false to send those events on staging while you test, then set it back to true.
 */
export const TRACKING_PRODUCTION_ONLY = true;

const PRODUCTION_HOSTS = new Set(["albacars.ae", "www.albacars.ae"]);

export const isTrackingEnabled = (): boolean => {
  if (!TRACKING_PRODUCTION_ONLY) {
    return true;
  }

  if (process.env.NODE_ENV !== "production") {
    return false;
  }

  if (process.env.NEXT_PUBLIC_DEV_MODE === "true") {
    return false;
  }

  const appUrl = process.env.NEXT_PUBLIC_APP_URL ?? "";
  try {
    const host = new URL(appUrl).hostname.toLowerCase();
    return PRODUCTION_HOSTS.has(host);
  } catch {
    return false;
  }
};
